import capitalize from 'lodash/capitalize';
import classnames from 'classnames';
import { Button, TagPill } from 'components/common';
import { billing, format } from 'libs';
import { SolidStarIcon } from 'icons';

interface AddonSubscription {
  active_discount?: { coupon: { percent_off?: number } };
  discounts?: { coupon?: { percent_off?: number } };
  price: {
    description?: string;
    frequency?: string;
    link?: string;
    name?: string;
    price?: number;
    stripe_price?: string;
  };
  stripe_status?: string;
  type?: string;
}

interface DowngradeAddonSubscriptionProps {
  isPastDue: boolean;
  onShowModal: (subscription: AddonSubscription) => void;
  subscription: AddonSubscription;
}

const DowngradeAddonSubscription = ({ isPastDue, onShowModal, subscription }: DowngradeAddonSubscriptionProps) => (
  <div className="card" data-testid={`subscriptions-downgrade-addon-card-${subscription.type}`}>
    <div className="card-body">
      <div>
        <div className="align-items-center d-flex">
          <img alt={`${subscription.type} icon`} height={76} src={`/images/${subscription.type}.png`} width={76} />
          <div className="flex-column ms-3">
            <div className="align-items-center d-flex flex-row">
              <h4 className="fw-bold mb-0 me-2">{subscription.price.name}</h4>
              {subscription.active_discount && <TagPill icon={<SolidStarIcon />}>One month discount</TagPill>}
            </div>
            <div className="fw-bold text-1_125">
              <span
                className={classnames({ 'pe-1 text-line-through text-heading-light': subscription.active_discount })}
              >
                ${subscription.price.price! / 100} / {capitalize(subscription.price.frequency)}
              </span>
              {subscription.active_discount && (
                <span className="fw-bold">
                  {format.currency(billing.discount(subscription.price, subscription.active_discount.coupon) / 100)}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="my-3">
          {isPastDue ? (
            <span>
              You cannot downgrade your add-on subscription while any of your subscription payments are past due.
            </span>
          ) : (
            <span>
              {subscription.price.description}{' '}
              <a className="text-primary-dark" href={subscription.price.link} target="_blank" rel="noreferrer">
                Learn more
              </a>
            </span>
          )}
        </div>
      </div>
      <Button
        disabled={isPastDue}
        onClick={() => onShowModal(subscription)}
        testId={`subscriptions-downgrade-addon-button-${subscription.type}`}
        text="bold"
        variant="border-danger"
      >
        Downgrade add-on
      </Button>
    </div>
  </div>
);

export default DowngradeAddonSubscription;
